module.exports = __webpack_public_path__ + "MaterialIcons-Regular.012cf6a10129e2275d79.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@covalent/core/common/styles/font/MaterialIcons-Regular.woff
// module id = 2047
// module chunks = 2